export enum ProCoursesStatusEnum {
	ALL_PROGRAM = 'All_Program',
	AI_DATA = 'Ai_Data',
	CYBER_CLOUD_ENGINEER = 'cyber_cloud_engineer',
	FULL_STACK_DEVELOPER = 'full_stack_developer',
	DESING_PRODUCT = 'design_product',
	EMERGING_TECH = 'emerging_tech',
}


export enum MyLearningStatuEnum {
	LESSON = 'lesson',
	DAILY_CHALLENGE = 'daily_challenge'
}